module.exports = __webpack_public_path__ + "static/media/feature_ellipse_1.5d6636d8.png";